// import '../../public/images'


const popularApi =[
    {
      id:1,
      name:'Tasty Burger',
      img:"images/p-1.jpg",
      price:220,
  },
  {
    id:2,
    name:'tasty cakes',
    img:"images/p-2.jpg",
    price:120
  },
  {
    id:3,
    name:'tasty sweets',
    img:"images/p-3.jpg",
    price:280,
  },
  {
    id:4,
    name:'tasty cupcakes',
    img:"images/p-4.jpg",
    price:150,
  },
  {
    id:5,
    name:'cold drinks',
    img:"images/p-5.jpg",
    price:80,
  },
  {
    id:6,
    name:'cold ice-cream',
    img:"images/p-6.jpg",
    price:180,
  },


  
  
  
  ]
  
  
  
  export default popularApi;